let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dB9J6")).then(() => parcelRequire('7OgRC'));